// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"75e4d40a","247":"25293f67","422":"915d6134","627":"03a7f16f","653":"4f1e1679","834":"3dc47c8f","867":"7913c3b9","923":"c66eff7e","938":"b6edf72b"}[chunkId] + ".chunk.js";
};